import { Component, HostListener } from '@angular/core';
import { NgFor, NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';

type Link = { label: string; routerLink?: string; href?: string; target?: string };

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [NgFor, NgIf, RouterLink],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  year = new Date().getFullYear();

  // ===== Columna 1: Productos (Alphatec Scientific®)
  col1 = [
    {
      title: 'ALPHATEC SCIENTIFIC®',
      links: <Link[]>[
        { label: 'Chemistry',    routerLink: '/categoria/chemistry' },
        { label: 'Hematology',   routerLink: '/categoria/hematology' },
        { label: 'COLOSSO® Immunology', routerLink: '/categoria/immunology' },
        { label: 'ALPHAQUARTZ® Urinalysis', routerLink: '/categoria/urinalysis' },
        { label: 'EOLO® Centrifuges', routerLink: '/categoria/centrifuges' },
        { label: 'ASTREO® Microscopes', routerLink: '/categoria/microscopes' },
      ]
    }
  ];

  // ===== Columna 2: Software, Boreas y Cuidado Animal
  col2 = [
    {
      title: 'ALPHANAPSIS®',
      links: <Link[]>[
        { label: 'LIS Clínico (Plus)', routerLink: '/software/lis' },
        { label: 'Banco de Sangre (Red)', routerLink: '/software/blood-bank' },
        { label: 'Vet LIS', routerLink: '/software/vet-lis' },
      ]
    },
    {
      title: 'BOREAS®',
      links: <Link[]>[{ label: 'Línea de Refrigeración', routerLink: '/categoria/refrigeration' }]
    },
    {
      title: 'CUIDADO ANIMAL',
      links: <Link[]>[
        { label: 'Chemistry Vet', routerLink: '/categoria/chemistry?vet=1' },
        { label: 'Hematology Vet', routerLink: '/categoria/hematology?vet=1' },
        { label: 'Immunology Vet', routerLink: '/categoria/immunology?vet=1' },
        { label: 'Urinalysis Vet', routerLink: '/categoria/urinalysis?vet=1' },
        { label: 'Monitores de Signos Vitales', routerLink: '/categoria/monitors' },
        { label: 'Bombas de Infusión', routerLink: '/categoria/infusion' },
        { label: 'Radiología Digital', routerLink: '/categoria/radiology' },
      ]
    }
  ];

  // ===== Columna 3: Soporte / Políticas
  soporte = {
    title: 'SOPORTE Y SERVICIOS',
    links: <Link[]>[
      { label: 'Correo corporativo', href: 'mailto:info@alphatecscientific.com' },
      { label: 'Distribuidores', routerLink: '/nosotros#distribuidores' },
      { label: 'Libro de Reclamaciones', routerLink: '/reclamaciones' },
    ]
  };
  politicas: Link[] = [
    { label: 'Privacidad', routerLink: '/privacidad' },
    { label: 'Términos y Condiciones', routerLink: '/terminos' }
  ];

  onSubscribe(e: Event) {
    e.preventDefault();
    const email = (e.target as HTMLFormElement)
      .querySelector<HTMLInputElement>('input[type="email"]')?.value;
    if (email) alert(`¡Gracias! Te registraremos con: ${email}`);
  }

  // ===== Botón Volver Arriba =====
  showTop = false;

  @HostListener('window:scroll', [])
  onScroll() {
    const y = window.scrollY || document.documentElement.scrollTop || 0;
    this.showTop = y > 280; // aparece tras 280px de scroll
  }

  backToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
